import apiConfig from "../utils/instance/apiConfig";

const getUserInfo = async () => {
  try {
    const response = await apiConfig.get("/users/info-user");
    return response.data;
  } catch (error) {
    throw new Error("Error fetching user info");
  }
};

const servicePostChangePassword = async (payload) => {
  const response = await apiConfig.post("/users/changepassw", payload);
  return response.data;
};

export { getUserInfo, servicePostChangePassword };
